module.exports = __webpack_public_path__ + "img/btn_map.ac56b887.png";